module.exports = __webpack_public_path__ + "static/media/referralRegisterBanner.b585ba79.png";